import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router';
import { Helmet } from 'react-helmet-async';
import { TFunction, withTranslation } from 'react-i18next';
import { getPet } from '../api/petApi';
import FetchError from '../types/http';
import { PetInterface } from '../types/pet';
import Layout from '../components/starter-guide/LayoutPuppyGuide';
import { isClient } from '../util/helpers';

function useLocationQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const PuppyGuide = ({ t }: { t: TFunction<string> }) => {
  useEffect(() => {
    if (isClient()) {
      const navEntries = window.performance?.getEntriesByType('navigation');
      if (
        !navEntries ||
        navEntries.length === 0 ||
        (navEntries[0].type !== 'back_forward' && navEntries[0].type !== 'reload')
      ) {
        window.scrollTo(0, 0);
      }
    }
  }, []);
  let query = useLocationQuery();
  const petProfileId = query.get('petProfileId');
  const isEnabled = !!petProfileId && Number(petProfileId) > 0;
  const { data, isLoading } = useQuery<PetInterface, FetchError>(
    [getPet.key, petProfileId],
    getPet,
    { enabled: isEnabled },
  );
  return (
    <>
      <Helmet>
        <title>{t('puppyGuide.metaData.title')}</title>
      </Helmet>
      <Layout isLoading={isLoading} data={data} />
    </>
  );
};

export default withTranslation()(PuppyGuide);
